// Local storage facade for global messages
const getLocalStorageKey = (id: string): string => `willys.GlobalMessage-${id}`;

export const getGlobalMessageDisplayState = (uid: string): string | null => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(getLocalStorageKey(uid));
};

export const setGlobalMessageDisplayState = (uid: string): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(getLocalStorageKey(uid), 'true');
};
